"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _box = _interopRequireDefault(require("./box"));
var _default = _box["default"];
exports["default"] = _default;